/**
 * Review Repository Implementation
 * Implements the ReviewRepository interface
 * Coordinates between API calls and mappers
 */

import { ReviewRepository } from "../../domain/repositories/ReviewRepository";
import { ReviewRequestEntity } from "../../domain/entities/ReviewEntity";
import {
  getPendingReviews as getPendingReviewsApi,
  getMyReviewRequests as getMyReviewRequestsApi,
  checkApprovedReview as checkApprovedReviewApi,
  createReviewRequest as createReviewRequestApi,
  approveReview as approveReviewApi,
  rejectReview as rejectReviewApi,
} from "../api/reviewsApi";
import { ReviewMapper } from "../mappers/ReviewMapper";
import {
  PendingReviewsResponseDTO,
  MyReviewRequestsResponseDTO,
  CheckApprovedReviewResponseDTO,
} from "../models/ReviewDTOs";

export class ReviewRepositoryImpl implements ReviewRepository {
  async getPendingReviews(): Promise<ReviewRequestEntity[]> {
    const response =
      (await getPendingReviewsApi()) as PendingReviewsResponseDTO;
    return ReviewMapper.toReviewRequestEntityArray(response);
  }

  async getMyReviewRequests(): Promise<ReviewRequestEntity[]> {
    const response =
      (await getMyReviewRequestsApi()) as MyReviewRequestsResponseDTO;
    return ReviewMapper.toMyReviewRequestsEntityArray(response);
  }

  async checkApprovedReview(params: {
    user_id: number;
    entity_type: string;
    entity_id: number;
    action_code: string;
  }): Promise<ReviewRequestEntity | null> {
    const response = (await checkApprovedReviewApi(
      params
    )) as CheckApprovedReviewResponseDTO;
    return ReviewMapper.toApprovedReviewEntity(response);
  }

  async createReviewRequest(data: {
    module_code: string;
    action_code: string;
    entity_type: string;
    entity_id: number;
    request_comments?: string;
  }): Promise<{ review_id: number }> {
    const response = await createReviewRequestApi(data);
    return { review_id: response.data?.review_id || 0 };
  }

  async approveReview(id: number, comments?: string): Promise<void> {
    await approveReviewApi(id, comments);
  }

  async rejectReview(id: number, comments: string): Promise<void> {
    await rejectReviewApi(id, comments);
  }
}
